export const getOrderGuidsEndpoint = () => {
  const { endpoints } = window.Grab.config;
  const { apiGateWay } = endpoints;
  return `${apiGateWay}/expresshub/web/v1/getorderguids`;
};

export default {};
